import React from 'react';
import { useNavigate } from 'react-router-dom';
const Terms = () => {
    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

  return (
    <div className="legal-page">
    <button className="back-button" onClick={handleBack}>
        ← Back
    </button>
      <h1>Terms of Service</h1>
      <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>
      
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing and using the web portal located at https://projects.mtsolar.us (the "Service"), 
        you accept and agree to be bound by the terms and provision of this agreement. If you do not 
        agree to abide by the above, please do not use this service.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        This web portal is designed to facilitate the design and ordering of solar products. Users can 
        create projects, design solar systems, request quotes, and process orders through our platform. 
        The service is provided for legitimate business purposes related to solar product procurement.
      </p>

      <h2>3. User Accounts</h2>
      <p>
        To access certain features of the Service, you may be required to create an account. You are 
        responsible for maintaining the confidentiality of your account credentials and for all activities 
        that occur under your account. You agree to notify us immediately of any unauthorized use of your 
        account.
      </p>

      <h2>4. Data Collection and Privacy</h2>
      <p>
        We collect and process personal and project data solely for the purpose of creating and processing 
        product orders. This includes but is not limited to:
      </p>
      <ul>
        <li>Contact information (name, email, phone number, address)</li>
        <li>Project specifications and design requirements</li>
        <li>Quote and order information</li>
        <li>Communication records related to your projects</li>
      </ul>
      <p>
        We do not sell, rent, or share your personal information with third parties except as necessary 
        to fulfill your orders or as required by law. Your data is used exclusively for the purpose of 
        providing our solar product design and ordering services.
      </p>

      <h2>5. Acceptable Use</h2>
      <p>You agree to use the Service only for lawful purposes and in accordance with these Terms. You agree not to:</p>
      <ul>
        <li>Use the Service for any illegal or unauthorized purpose</li>
        <li>Attempt to gain unauthorized access to any part of the Service</li>
        <li>Interfere with or disrupt the Service or servers connected to the Service</li>
        <li>Upload or transmit any harmful code, viruses, or malicious software</li>
        <li>Impersonate any person or entity or misrepresent your affiliation with any person or entity</li>
      </ul>

      <h2>6. Intellectual Property</h2>
      <p>
        The Service and its original content, features, and functionality are and will remain the exclusive 
        property of MTSolar and its licensors. The Service is protected by copyright, trademark, and other 
        laws. Our trademarks and trade dress may not be used in connection with any product or service 
        without our prior written consent.
      </p>

      <h2>7. Product Information and Quotes</h2>
      <p>
        All product information, specifications, and quotes provided through the Service are for informational 
        purposes only. While we strive for accuracy, we do not warrant that all information is complete, 
        current, or error-free. Final pricing and availability are subject to confirmation at the time of order.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        In no event shall MTSolar, nor its directors, employees, partners, agents, suppliers, or affiliates, 
        be liable for any indirect, incidental, special, consequential, or punitive damages, including without 
        limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use 
        of the Service.
      </p>

      <h2>9. Disclaimer</h2>
      <p>
        The information on this Service is provided on an "as is" basis. To the fullest extent permitted by 
        law, MTSolar excludes all representations, warranties, conditions and terms relating to our Service 
        and the use of this Service.
      </p>

      <h2>10. Termination</h2>
      <p>
        We may terminate or suspend your account and bar access to the Service immediately, without prior 
        notice or liability, under our sole discretion, for any reason whatsoever and without limitation, 
        including but not limited to a breach of the Terms.
      </p>

      <h2>11. Changes to Terms</h2>
      <p>
        We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a 
        revision is material, we will provide at least 30 days notice prior to any new terms taking effect.
      </p>

      <h2>12. Governing Law</h2>
      <p>
        These Terms shall be interpreted and governed by the laws of the jurisdiction in which MTSolar 
        operates, without regard to its conflict of law provisions.
      </p>

      <h2>13. Contact Information</h2>
      <p>
        If you have any questions about these Terms of Service, please contact us through the Service 
        or at the contact information provided on our website.
      </p>

      <p className="legal-page__updated">
        By using this Service, you acknowledge that you have read and understood these Terms of Service 
        and agree to be bound by them.
      </p>
    </div>
  );
};

export default Terms;
